(ns ycweb.app.blitz.aftersales.prereceiving
  (:require
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.header :as header]
   [ycweb.components.feedback :as feedback]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.app.pos.menu :as menu]
   [ycweb.components.flow :as flow]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.transitions :as t]
   [ycweb.util.date :as ud]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [util.string :as str]
   [inflections.core :as inflections]))

(rum/defc screen-wrapper [app-atom {:keys [modal-fn]} steps progress-step body foot-note call-to-action]
  [:div.page-body
   (header/header app-atom "Aftersales Prereceiving" {})
   (header/menu-overlay (rum/cursor app-atom :menu))
   (header/menu app-atom (menu/select-menus app-atom))
   (into
     [:div.page-body__main-content
      (when modal-fn
        [:nav.section.button-bar
         (buttons/button
           " Options"
           #(modal-fn app-atom)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})])
      [:div.section
       (forms/progress-steps
         (forms/progress-step steps progress-step))]]
     body)
   (into
     [:aside.page-body__footer]
     foot-note)
   call-to-action])

(def steps
  (forms/setup-steps
    [{:key :returncas-search :title "YCR Number"}
     {:key :returncase-list :title "Select YCR"}
     {:key :returncase-details :title "Enter YCR Details"}
     {:key :location-scan :title "Scan Location"}
     {:key :printer-scan :title "Scan Printer"}
     {:key :confirm-printed :title "Confirm Printed"}
     {:key :finished :title "Done"}]))

(rum/defc returncase-search < rum/reactive [app-atom]
  (let [search-atom (rum/cursor-in app-atom [:aftersalesprereceiving :returncase-search])]
    (screen-wrapper app-atom {} steps :returncas-search
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Enter YCR Number"]
        (forms/input "YCR Number:" "YCR123456" search-atom)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when-not (str/blank? (rum/react search-atom))
           #(grid/dispatch-action app-atom
              :aftersalesprereceiving/returncase-list {}))}))))

(defmethod flow/render-screen :aftersalesprereceiving/returncase-search [app-atom screen]
  (returncase-search app-atom))

(defmethod grid/action :aftersalesprereceiving/returncase-list [app-atom config _]
  (toaster/open-toast app-atom :processing "Loading returncases" {})
  (comms/send :aftersalesprereceiving/returncase-list
    {:search (get-in @app-atom [:aftersalesprereceiving :returncase-search])}))

(defmethod comms/receive :aftersalesprereceiving/returncase-list [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:aftersalesprereceiving :returncases] (:returncases e))
  (t/transition-next app-atom :aftersalesprereceiving/returncase-list))

(rum/defc returncase-slat < rum/reactive
  [{:keys [status customer-name refid dateadded]} {:keys [on-click]}]
  [:article.slat.return-order-slat
   {:on-click (when on-click on-click)}
   [:h1.return-order-slat__title
    [:span.return-order-slat__order-no (str "YCR" refid)]]
   [:ul.return-order-slat__detail-list
    [:li.return-order-slat__detail-item
     [:b
      customer-name]]
    [:li.return-order-slat__detail-item
     [:b "Date Added: "]
     (ud/format-date dateadded "EEE, dd MMM yyyy")]]
   [:div.return-order-slat__status-wrapper
    [:span.return-order-slat__status
     [:b status]]]])

(rum/defc returncase-list < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesprereceiving])]
    (screen-wrapper app-atom {} steps :returncase-list
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Returncases"]]
       (map
         (fn [i]
           (rum/with-key
             (returncase-slat
               i
               {:on-click
                #(grid/dispatch-action app-atom :aftersalesprereceiving/returncase-details {:returncase i})})
             (:id i)))
         (cmn/curact current-atom :returncases))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :aftersalesprereceiving/returncase-list [app-atom screen]
  (returncase-list app-atom))

(defmethod grid/action :aftersalesprereceiving/returncase-details [app-atom {:keys [returncase]}]
  (swap! app-atom assoc-in [:aftersalesprereceiving :returncase] returncase)
  (t/transition-next app-atom :aftersalesprereceiving/returncase-details))

(rum/defc returncase-details < rum/reactive [app-atom]
  (let [returncase-atom (rum/cursor-in app-atom [:aftersalesprereceiving :returncase])]
    (screen-wrapper app-atom {} steps :returncase-details
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Enter Details"
         [:span.heading__subtext "YCR" (cmn/curact returncase-atom :refid)]
         [:span.heading__subtext (cmn/curact returncase-atom :customer-name)]]

        (forms/input "Number of Boxes:" "3" (rum/cursor-in returncase-atom [:boxcount])
          {:type :number})

        (datepicker/datepicker app-atom "Date Arrived:" "dd-mm-yyyy"
          [:aftersalesprereceiving :returncase :datearrived]
          {:header "Date Arrived"
           :datatype :datedmy})

        (forms/textarea "Notes:"
          (rum/cursor-in returncase-atom [:notes]))]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :aftersalesprereceiving/returncase-list {})
         :right-text "Next"
         :right-fn
         (when
           (and
             (not (str/blank? (cmn/curact returncase-atom :datearrived)))
             (pos? (cmn/curact returncase-atom :boxcount)))
           #(grid/dispatch-action app-atom
              :aftersalesprereceiving/returncase-details-save {}))}))))

(defmethod flow/render-screen :aftersalesprereceiving/returncase-details [app-atom screen]
  (returncase-details app-atom))

(defmethod grid/action :aftersalesprereceiving/returncase-details-save [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving details" {})
  (let [{:keys [returncase uuid]} (get-in @app-atom [:aftersalesprereceiving])
        {:keys [id boxcount notes datearrived]} returncase]
    (comms/send :aftersalesprereceiving/returncase-details-save
      {:returncase-id id
       :uuid uuid
       :datearrived datearrived
       :boxcount boxcount
       :notes notes})))

(defmethod comms/receive :aftersalesprereceiving/returncase-details-save [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:aftersalesprereceiving :uuid] (str (u/uuid)))
  (t/transition-next app-atom :aftersalesprereceiving/location-scan))

(defmethod grid/action :aftersalesprereceiving/location-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersalesprereceiving/location-scan
     :input-key :scan
     :input-type :barcode}))

(defn location-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :aftersalesprereceiving/location-menu-barcode}

      {:label "Cancel"
       :action :aftersalesprereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc location-scan < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesprereceiving])
        {:keys [boxcount] :as returncase} (cmn/curact current-atom :returncase)
        box-text (inflections/pluralize boxcount "box")]
    (screen-wrapper app-atom {:modal-fn location-menu-modal} steps :location-scan
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Location"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "and put the " box-text " there")]]
        [:div
         [:i.u-block-center
          {:class
           (u/bem
             :icon
             [:2-1 :barcode-scan :light-force :enormous :block])}]]]]
      [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
        (str "Remember to put the " box-text " in the location you scan")]]

      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :aftersalesprereceiving/returncase-details {:returncase returncase})
         :right-text "Scan Location"
         :right-plain true}))))

(defmethod flow/render-screen :aftersalesprereceiving/location-scan [app-atom screen]
  (location-scan app-atom))

(defmethod flow/barcode-dispatch-screen :aftersalesprereceiving/location-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesprereceiving/location-scan {:scan scan}))

(defmethod grid/action :aftersalesprereceiving/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesprereceiving/location-scan
    {:returncase-id (get-in @app-atom [:aftersalesprereceiving :returncase :id])
     :scan scan}))

(defmethod comms/receive :aftersalesprereceiving/location-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :aftersalesprereceiving/printer-scan))

(defmethod grid/action :aftersalesprereceiving/printer-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersalesprereceiving/printer-scan
     :input-key :scan
     :input-type :barcode}))

(defn printer-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :aftersalesprereceiving/printer-menu-barcode}

      {:label "Cancel"
       :action :aftersalesprereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc printer-scan < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:aftersalesprereceiving])
        {:keys [boxcount]} (cmn/curact current-atom :returncase)
        box-text (inflections/pluralize boxcount "box")]
    (screen-wrapper app-atom {:modal-fn printer-menu-modal} steps :printer-scan
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Printer"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "and put the stickers on the " box-text)]]
        [:div
         [:i.u-block-center
          {:class
           (u/bem
             :icon
             [:2-1 :barcode-scan :light-force :enormous :block])}]]]]
      [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
        (str "Remember to put the stickers on the " box-text)]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :aftersalesprereceiving/printer-scan [app-atom screen]
  (printer-scan app-atom))

(defmethod flow/barcode-dispatch-screen :aftersalesprereceiving/printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesprereceiving/printer-scan {:scan scan}))

(defmethod grid/action :aftersalesprereceiving/printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesprereceiving/printer-scan
    {:returncase-id (get-in @app-atom [:aftersalesprereceiving :returncase :id])
     :scan scan}))

(defmethod comms/receive :aftersalesprereceiving/printer-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :aftersalesprereceiving/confirm-printed))

(rum/defc confirm-printed < rum/reactive
  [app-atom]
  (let [returncase-atom (rum/cursor-in app-atom [:aftersalesprereceiving :returncase])
        box-text (inflections/pluralize (cmn/curact returncase-atom :boxcount) "box")]
    (screen-wrapper app-atom {} steps :confirm-printed
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Sticker"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "that you've put on the " box-text)]]
        [:div
         [:i.u-block-center
          {:class
           (u/bem
             :icon
             [:2-1 :barcode-scan :light-force :enormous :block])}]]]
       [:div.u-margin-bottom-24
        {:class (u/bem :section [:medium])}
        (feedback/action-feedback :package "" (str "The stickers are on the " box-text) (rum/cursor-in returncase-atom [:sticker-confirmed]) {})]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Sticker"
         :right-no-icon true
         :right-plain (cmn/curact returncase-atom :sticker-confirmed)}))))

(defmethod flow/render-screen :aftersalesprereceiving/confirm-printed [app-atom screen]
  (confirm-printed app-atom))

(defmethod flow/barcode-dispatch-screen :aftersalesprereceiving/confirm-printed [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersalesprereceiving/confirm-printed-scan {:scan scan}))

(defmethod grid/action :aftersalesprereceiving/confirm-printed-scan [app-atom {:keys [scan]} _]
  (cond
    (not (get-in @app-atom [:aftersalesprereceiving :returncase :sticker-confirmed]))
    (toaster/open-toast app-atom :warning "Confirm sticker before scanning" {})

    (not=
      (str (get-in @app-atom [:aftersalesprereceiving :returncase :refid]))
      (str/replace scan #"[^0-9]" ""))
    (toaster/open-toast app-atom :warning "YCR does not match" {})

    :else
    (t/transition-next app-atom :aftersalesprereceiving/finished)))

(rum/defc finished < rum/reactive
  [app-atom]
  (let [returncase-atom (rum/cursor-in app-atom [:aftersalesprereceiving :returncase])]
    (screen-wrapper app-atom {}
      steps :finished
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b "Thank you!"]]
        [:i.u-block-center
         {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
        [:div.u-margin-top-24
         [:p.u-text-center
          {:class (u/bem :paragraph [:large])}
          [:b
           (str "YCR" (cmn/curact returncase-atom :refid))
           [:br]
           "has been pre-received"]]
         [:p.u-text-center
          {:class (u/bem :paragraph [:flush])}
          "You still need to check the stock and receive it properly, but the driver can go."]]]]

      []

      (grid/pos-call-to-action
        {:single-fn #(grid/dispatch-action app-atom :aftersalesprereceiving/finished {})}))))

(defmethod flow/render-screen :aftersalesprereceiving/finished [app-atom screen]
  (finished app-atom))

(defmethod grid/action :aftersalesprereceiving/finished [app-atom config _]
  (swap! app-atom assoc :aftersalesprereceiving nil)
  (t/transition-next app-atom :aftersalesprereceiving/returncase-search))